import React, { useState, useEffect } from 'react';
import mainApiClient from '../../../services/interceptor.mainApiClient';
import { normalizePeopleResponse } from '../../../utils/responseNormalizer';
import { isDemoMode } from '../../../services/demoMode';
import { getDemoPeopleList } from '../../../services/demoData.service';

const PolPersonIdInput = ({ personId, setPersonId, demoMode, setDemoMode }) => {
  const [people, setPeople] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadPeople();
  }, [demoMode]);

  const loadPeople = async () => {
    setLoading(true);
    try {
      if (isDemoMode()) {
        setPeople(getDemoPeopleList());
      } else {
        const response = await mainApiClient.get('people/aliens', { params: { page: 1, pageSize: 10000 } });
        const result = normalizePeopleResponse(response.data);
        if (Array.isArray(result)) {
          setPeople(result);
        } else {
          setPeople([]);
        }
      }
    } catch (err) {
      console.error('[PolPersonIdInput] Failed to load people:', err);
      setPeople([]);
    } finally {
      setLoading(false);
    }
  };

  const getDisplayName = (person) => {
    const name = person.peopleName || person.alienName ||
      (person.firstName && person.lastName ? `${person.firstName} ${person.lastName}` : null);
    const id = person.alienId || person.peopleId;
    return name ? `${name} (${id})` : `Subject ${id}`;
  };

  return (
    <div className="bg-white rounded-lg shadow p-4 mb-6">
      <div className="flex flex-wrap items-end gap-4">
        <div className="flex-1 min-w-[200px]">
          <label className="block font-semibold mb-1">Subject</label>
          <select
            value={personId}
            onChange={(e) => setPersonId(e.target.value)}
            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
            disabled={loading}
          >
            <option value="">
              {loading ? 'Loading subjects...' : '-- Select a subject --'}
            </option>
            {people.map((person) => {
              const id = person.alienId || person.peopleId;
              return (
                <option key={id} value={id}>
                  {getDisplayName(person)}
                </option>
              );
            })}
          </select>
        </div>

        {/* Demo Mode Toggle */}
        {setDemoMode && (
          <div className="flex items-center gap-2">
            <button
              onClick={() => setDemoMode(!demoMode)}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${
                demoMode ? 'bg-amber-500' : 'bg-gray-300'
              }`}
              role="switch"
              aria-checked={demoMode}
              aria-label="Toggle demo mode"
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                  demoMode ? 'translate-x-6' : 'translate-x-1'
                }`}
              />
            </button>
            <span className={`text-sm font-medium ${demoMode ? 'text-amber-600' : 'text-gray-500'}`}>
              Demo
            </span>
            {demoMode && (
              <span className="text-xs bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full font-medium">
                Simulated Data
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PolPersonIdInput;
